export const text = 'text';
export const number = 'number';
export const email = 'email';
export const time = 'time';
export const date = 'date';
